module.exports = __webpack_public_path__ + "img/bronze-medal.70035095.png";